import { useIntl } from 'react-intl';
import { useLocation } from 'react-router-dom';

export const useCurrentStep = () => {
    const location = useLocation();
    const { locale } = useIntl();
    const accountSignupRegex =
        locale === 'de' ? /\/konto\/anmeldung\//g : /\/account\/signup\//g;

    const currentStep = location.pathname
        .replace(accountSignupRegex, '')
        .replace(/\//g, '');

    return currentStep;
};
